import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取订单报表列表
   * @param MaxResultCount
   * @param currentPage
   * @param OrderNo
   */
  getOrderReportList(
    MaxResultCount: number,
    currentPage: number,
    OrderNo?: string,
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      OrderNo,
    }
    return Ajax.get(`/api/OrderManagement/order`, {
      params: params
    })
  },
  /**
   * 获取登录日志报表
   * @param MaxResultCount 
   * @param currentPage 
   */
  getLoginLogData(
    MaxResultCount: number,
    currentPage: number, ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    return Ajax.get('/api/Report/LoginLog', {
      params: params
    })
  },
  /**
   * 获取商品销售分析列表
   * @param MaxResultCount 
   * @param currentPage 
   */
  getSalesAnalysisList(
    MaxResultCount: number,
    currentPage: number,
    KeyWord: string
  ) {
    let params = {
      KeyWord,
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    return Ajax.get('/api/Report/ProductSale/GetList', {
      params: params
    })
  },
  /**
   * 导出订单报表
   */
  exportExcel(
    MaxResultCount: number,
    currentPage: number,
    OrderNo?: string
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      OrderNo
    }
    return Ajax.get('/api/OrderManagement/order/exportOrderFile', {
      params: params,
      responseType: "blob"
    })
  },
  /**
  * 导出销售数据报表
  */
  exportSaleAnalyExcel(keyWord:string) {
    return Ajax.get('/api/Report/ProductSale/exportFile', {
      responseType: "blob",
      params:{
        keyWord
      }
    })
  },
  /**
   * 导出登录日志报表
   */
  // exportLoginLogExcel() {
  //   return Ajax.get('')
  // }
}
